import React from "react";
import { useParams } from "react-router";
import { IframeComponent } from "../../components/IframeComponent";
import { getCookie } from "../../utils/cookie";
import { viewerUrl } from "../../config";

export const ViewerPage = () => {
  const { id, classId } = useParams();
  const token = getCookie("dynos_plus_session");
  return (
    <IframeComponent
      src={
        classId
          ? `${viewerUrl}/${id}/${classId}/?dynosplus=true&token=${token}`
          : `${viewerUrl}/${id}/?dynosplus=true&token=${token}`
      }
      title="Dynos Viewer"
    />
  );
};
